



































import { defineComponent, PropType, computed } from "@vue/composition-api";
import { UserItem } from "./types";
import { ThreadStatus } from "@/pb/scout/message/v1/message_pb";
import { getCurrentRootURL } from "@/helpers/url-helper";

export default defineComponent({
  name: "UserHeader",
  emits: ["open-detail"],
  props: {
    user: {
      type: Object as PropType<UserItem>,
      required: true
    },
    threadStatus: {
      type: Number as PropType<ThreadStatus>,
      required: true
    }
  },
  setup(props, { emit }) {
    const showUserName = computed(() => {
      return (
        props.user.lastName !== undefined &&
        props.user.firstName !== undefined &&
        props.user.lastName.length > 0 &&
        props.user.firstName.length > 0
      );
    });

    const primaryIdentifier = computed(() => {
      if (showUserName.value) {
        return `${props.user.lastName} ${props.user.firstName}`;
      } else {
        return props.user.uniqueId;
      }
    });

    const descriptionFirst = computed(() => {
      return `${props.user.grade} ${props.user.graduateYear}`;
    });

    const handleClickedOpenDetail = (userId: number) => {
      if (props.threadStatus === ThreadStatus.THREAD_STATUS_ACCEPTED) {
        // 受諾済みの場合は応募者として取り扱うので、別タブで応募者詳細を開く
        const applicantDetailUrl = `${getCurrentRootURL()}/job/applicants/${userId}`;
        window.open(applicantDetailUrl, "_blank", "noopener");
      } else {
        emit("open-detail", userId);
      }
    };

    return {
      showUserName,
      primaryIdentifier,
      descriptionFirst,
      handleClickedOpenDetail
    };
  }
});
